import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Pill, PillStatus } from '@teamsnap/teamsnap-ui';

const propTypes = {
  status: PropTypes.oneOf([PillStatus.ACTIVE, PillStatus.ERROR]).isRequired,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

type Props = PropTypes.InferProps<typeof propTypes>;

const FlexPillButton = ({ status, onClick, children }: Props) => {
  const styles = {
    height: '71px',
    paddingLeft: 30,
    paddingRight: 20,
    marginBottom: 24,
    fontSize: '18px',
    fontWeight: 600,
    position: 'relative' as 'relative',
  };

  return (
    <Pill
      testId="add-waiver-button"
      mods="u-flex u-flexAlignItemsCenter clickable sui-cursor-pointer"
      style={styles}
      status={status}
      onClick={onClick}
    >
      {children}
    </Pill>
  );
};

export default FlexPillButton;
